import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import taxi from './belfast-cab-tour-blog.png';
import newLodgeMural from '../assets/images/belfast-taxi-tours-new-lodge-road.jpg';
import belfastBestCity from '../assets/images/belfast-cab-tour-belfast-best-city.jpg';
import belfastOldPark from '../assets/images/belfast-taxi-tours-oldpark.jpg';
import giantsCauseway from '../assets/images/giants-causeway.jpg';
import '../Styles.css';

const Blog = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
      }}
    >
      {/* ✅ Helmet for page title & meta tags */}
      <Helmet>
        <title>Belfast Taxi Tours Blog | Explore Belfast History & Landmarks</title>
        <meta
          name="description"
          content="Read our Belfast Taxi Tours blog to discover the city's political murals, history, and top sightseeing experiences including Giant's Causeway and local cab tours."
        />
      </Helmet>

      <Navbar />

      {/* Header Section */}
      <header className="Packages-header" style={{ marginTop: '60px' }}>
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%',
              transform: `translateY(-${scrollTop / 100}%)`,
            }}
          />
        </div>
      </header>

      <main style={{ padding: '0 1rem', maxWidth: 900, margin: '0 auto' }}>
        <div className="Blog-content-divider">
          <br />
        </div>

        {/* New Lodge Mural */}
        <div className="Blog-content-mural-painting-home">
          <img
            src={newLodgeMural}
            alt="new-lodge-mural"
            className="new-lodge-mural"
          />
        </div>

        {/* Political Taxi Tours */}
        <article style={{ marginBottom: '3rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            Discover Belfast's Past: Political Taxi Tours in Belfast
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
              I never thought a taxi ride could be so much more than just getting
              from point A to B—but my Belfast political tour completely changed
              that. Climbing into one of the city’s iconic black taxis, I felt like
              I was about to step into the living history of Belfast itself.
            </p>
            <p>
              Our driver-guide, who grew up through The Troubles, navigated the
              winding streets of West Belfast with stories that brought murals,
              towering Peace Walls, and everyday neighborhoods to life. Walking and
              sometimes pausing beside these monumental walls, I could feel the weight
              of the city’s past—and the resilience of the people who live there.
            </p>
            <p>
              We drove down both Falls Road and Shankill Road, and I couldn’t help
              but stop to stare at the murals. Each piece of art told a story of grief,
              defiance, and hope. I found myself imagining the lives of the people
              behind these messages, and realizing that history here isn’t something
              you just read—it’s something you see, hear, and feel.
            </p>
            <p>
              One of the highlights was a “two-in-one” tour where guides from
              different sides shared their experiences. Hearing both perspectives
              gave me a real sense of the complexity, the pain, and also the hope
              that Belfast carries. By the end of the day, I didn’t just understand
              the history—I understood a little more about the people who are
              shaping the city’s future.
            </p>
            <p>
              If you’re visiting Belfast and want a tour that’s full of emotion,
              storytelling, and genuine insight, hopping in one of these black taxis
              is an experience I’ll never forget. It’s history you don’t just learn—
              it’s history you live.
            </p>
          </section>
        </article>

        {/* Belfast Best City */}
        <div className="Blog-content-mural-painting-home">
          <img
            src={belfastBestCity}
            alt="best-city"
            className="new-lodge-mural"
          />
        </div>

        {/* Cab Tour Experience */}
        <article style={{ marginBottom: '3rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            Belfast Cab Tour Experience
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
              If you want to truly understand Belfast's past and present, a
              black cab tour is an absolute must. I wasn't sure what to
              expect—maybe a quick drive around some murals—but it turned out
              to be one of the most personal and powerful experiences I've had
              while travelling. My driver was a local who had lived through the
              Troubles and shared stories not just from history books, but from
              his own life.
            </p>
            <p>
              We visited the famous political murals on Falls Road and Shankill
              Road, paused at the Peace Walls, and even signed our names
              alongside messages from visitors around the world. Each stop came
              with context, insight, and human emotion that no museum or
              guidebook could offer. What struck me most was the balanced
              perspective—this wasn't about taking sides, but about helping
              people understand the deep, complex history of a divided city
              working toward peace.
            </p>
            <p>
              The cab itself was comfortable, and the tour felt relaxed and
              informal, like a conversation rather than a lecture. It gave me a
              whole new appreciation for Belfast, its resilience, and its
              people. If you're visiting, don't miss this chance to see the
              city through a local's eyes.
            </p>
          </section>
        </article>

        {/* Old Park Mural */}
        <div className="Blog-content-mural-painting-home">
          <img
            src={belfastOldPark}
            alt="old-park"
            className="new-lodge-mural"
          />
        </div>

        {/* Belfast Taxi Tours */}
        <article style={{ marginBottom: '3rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            Belfast Taxi Tours – A Unique Way to Discover the City
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
              Belfast Taxi Tours are one of the most popular and authentic ways
              to explore the history, culture, and stories of Northern
              Ireland's capital. Unlike standard sightseeing trips, these tours
              are led by experienced local drivers who lived through the
              Troubles and can share first-hand accounts of life in Belfast.
              For anyone looking to understand the real story behind the city,
              a taxi tour is an unforgettable experience.
            </p>
            <p>
              During a Belfast Taxi Tour, you'll journey through key locations
              such as the Falls Road and Shankill Road, where world-famous
              political murals tell the story of conflict and community. You'll
              also visit the Peace Walls, where visitors from across the globe
              leave messages of hope and unity. Each stop is brought to life
              with personal insights, historical context, and stories you won't
              find in any guidebook.
            </p>
            <p>
              What makes Belfast Taxi Tours truly special is the balance they
              offer—drivers present different perspectives, helping visitors
              understand both sides of the city's divided past. The tours are
              comfortable, private, and conversational, making them ideal
              whether you're travelling solo, as a couple, or with family and
              friends. More than just a tour, it's a chance to connect with
              Belfast on a deeper level and leave with memories that last long
              after the journey ends.
            </p>
            <p>
              If you're planning a trip, booking a Belfast Taxi Tour is one of
              the best ways to see the city through the eyes of those who know
              it best. It's not just sightseeing—it's a powerful, personal
              introduction to Belfast's history, resilience, and ongoing story
              of peace.
            </p>
          </section>
        </article>

        {/* Giants Causeway */}
        <div className="Blog-content-mural-painting-home">
          <img
            src={giantsCauseway}
            alt="giants-causeway"
            className="new-lodge-mural"
          />
        </div>

        {/* Giant's Causeway */}
        <article style={{ marginBottom: '3rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            Giant's Causeway Experience
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
              Standing at the edge of the Giant's Causeway, with the wild North
              Atlantic crashing against those perfect hexagonal stones, felt
              like stepping into another world. Pictures don't do it
              justice—the scale, the sound, and the strange beauty of it all
              have to be experienced in person. The wind was fierce, but it
              only added to the drama of the setting.
            </p>
            <p>
              According to legend, the stones were built by the Irish giant
              Finn McCool, and honestly, it's easy to believe it when you see
              the size and precision of the formations. There's a magical,
              almost otherworldly quality to the place. The walk down to the
              stones is scenic and not too strenuous, with views that stretch
              out along the rugged Antrim coastline. I also explored the nearby
              visitor centre, which does a great job blending folklore with
              geology.
            </p>
            <p>
              Whether you're into natural wonders, mythology, or photography,
              the Giant's Causeway has something for everyone. It's a must-see
              if you're in Northern Ireland, and well worth the day trip from
              Belfast. Don't forget sturdy shoes and a waterproof jacket—it's
              Ireland, after all! But rain or shine, the experience will stay
              with you long after you've left.
            </p>
          </section>
        </article>
      </main>

      {/* Footer Section */}
      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto',
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default Blog;
